function getAmplitudeDeviceId(): string | undefined {
  return window.amplitude?.getInstance()?.options?.deviceId;
}

export function onAnalyticsReady(cb: () => void): void {
  if (window.analytics?.ready) {
    let isCalled = false;

    window.analytics.ready(() => {
      isCalled = true;

      cb();
    });

    window.setTimeout(() => {
      if (!isCalled) {
        cb();
      }
    }, 1_000);
  } else {
    cb();
  }
}

export function openPageWithAmplitudeDeviceId(page: string): void {
  onAnalyticsReady(() => {
    const deviceId = getAmplitudeDeviceId();
    const url = new URL(page);

    if (deviceId !== undefined) {
      url.searchParams.append('amp_device_id', deviceId);
    }

    window.open(url.href, '_self');
  });
}
